export function RakutenPayButton({
  disabled,
  loading,
  onClick,
}: {
  disabled?: boolean;
  loading?: boolean;
  onClick: (event: Event) => void;
}) {
  return (
    <div class="payButtonArea">
      <input
        type="submit"
        class="payButton rakutenPay"
        disabled={disabled}
        value=" "
        onClick={onClick}
      />
      {loading && (
        <div class="lds-ring" style={{ marginTop: '-3rem' }}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      )}
    </div>
  );
}
